export default __webpack_public_path__ + "static/media/Zenisha_Savaliya.54beb014.jpeg";